// import pages
import FooterB from "../layout/FooterB";
import AskBenSensei from "./AskBenSensei";

// import style
import "../../style/pages/question/question.scss";

const Question = () => {
  return (
    <div className="question-section">
      <div className="container main-section">
        <div className="responsive-main-section">
          <div className="title-section background-black">
            <a href="/question" className="title-link">
              <div className="title font-amaticsc-bold">
                Ask Ben-sensei a Question!
              </div>
              <div className="sub-title font-zenkurenaido">
                ベン先生に聞いてみよう！
              </div>
            </a>
          </div>
          <div className="content-section">
            <div className="en-content font-outfit-bold">
              Have a question about English or language learning that you’d like
              to ask Ben-sensei? Ask below! It might become{" "}
              <a href="/articles" className="en-question-link">
                an article
              </a>
              !
              <br />
              <br />
              If you need to contact BENKYO会 with a practical question about
              course enrollment or registration, please visit the{" "}
              <a href="/contact" className="en-question-link">
                Contact Us
              </a>{" "}
              page.
            </div>
            <div className="jp-content font-kleeone">
              英語や言語学習についてベン先生に聞きたいことがありますか？下に質問を
              どうぞ！{" "}
              <a href="/articles" className="en-question-link">
                記事
              </a>
              になるかもしれませんよ〜
              <br />
              <br />
              コースの登録や申し込みに関する質問がある場合は、
              <a href="/contact" className="en-question-link">
                お問い合わせページ
              </a>
              を ご覧ください
            </div>
          </div>
        </div>
      </div>
      <FooterB />
      <AskBenSensei />
    </div>
  );
};

export default Question;
